'use strict';

angular.module('mean.projects').factory('taskFilterService', ['$filter',
    function($filter) {
        var getList = function(tasks, trade, phase, lot, task) {
            var val = [];

            if(trade && phase && lot && task) {
                val = $filter('filter')(tasks, {
                                'trade': trade.name,
                                'phase': phase.name,
                                'lot': lot.name,
                                'task_code': task.name}, true);
            } else if(trade && phase && lot) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name,
                            'phase': phase.name,
                            'lot': lot.name}, true);
            } else if(trade && phase && task) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name,
                            'phase': phase.name,
                            'task_code': task.name}, true);
            } else if(phase && lot && task) {
                val = $filter('filter')(tasks, {
                            'phase': phase.name,
                            'lot': lot.name,
                            'task_code': task.name}, true);
            } else if(trade && phase) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name,
                            'phase': phase.name}, true);
            } else if(trade && lot) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name,
                            'lot': lot.name}, true);
            } else if(trade && task) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name,
                            'task_code': task.name}, true);
            } else if(phase && lot) {
                val = $filter('filter')(tasks, {
                            'phase': phase.name,
                            'lot': lot.name}, true);
            } else if(phase && task) {
                val = $filter('filter')(tasks, {
                            'phase': phase.name,
                            'task_code': task.name}, true);
            } else if(lot && task) {
                val = $filter('filter')(tasks, {
                            'lot': lot.name,
                            'task_code': task.name}, true);
            } else if(trade) {
                val = $filter('filter')(tasks, {
                            'trade': trade.name}, true);
            } else if(phase) {
                val = $filter('filter')(tasks, {
                            'phase': phase.name}, true);
            } else if(lot) {
                val = $filter('filter')(tasks, {
                            'lot': lot.name}, true);
            } else if(task) {
                val = $filter('filter')(tasks, {
                            'task_code': task.name}, true);
            } else {
                val = tasks;
            }

            return val;
        };

        return {
            getList: getList
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/task-filter-service.js